import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Stack,
  Button,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useAuth } from '../auth/AuthContext';
import lumeraLogo from '../assets/lumera-logo.svg';

export default function AppHeader() {
  const { user, logout } = useAuth();
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  const isAdmin = roles.includes('ADMIN');

  return (
    <AppBar
      position="sticky"
      elevation={0}
      color="transparent"
      sx={{
        backgroundColor: 'var(--app-glass)',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        backdropFilter: 'blur(14px)',
        color: 'text.primary',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          py: { xs: 0.5, md: 0.75 },
        }}
      >
        <Box
          component={RouterLink}
          to="/"
          className="interactive-lift"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'inherit',
            borderRadius: 3,
            px: 0.6,
            py: 0.4,
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.45)',
            },
          }}
        >
          <Box component="img" src={lumeraLogo} alt="Люмера" sx={{ width: 40, height: 40, mr: 1.25 }} />
          <Stack spacing={0} sx={{ lineHeight: 1 }}>
            <Box component="span" sx={{
              fontFamily: '"TT Travels Medium", "TT Norms Pro Regular", Arial, sans-serif',
              fontSize: { xs: '1.05rem', md: '1.2rem' },
              fontWeight: 500,
              letterSpacing: '0.03em',
              color: 'text.primary',
            }}>
              Люмера
            </Box>
            <Box component="span" sx={{
              fontFamily: '"TT Norms Pro Regular", Arial, sans-serif',
              fontSize: { xs: '0.72rem', md: '0.78rem' },
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'primary.main',
              mt: 0.35,
            }}>
              Контур качества
            </Box>
          </Stack>
        </Box>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 1, md: 1.5 }}
          alignItems="center"
          sx={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}
        >
          {isAdmin && (
            <Button
              component={RouterLink}
              to="/admin/users"
              variant="contained"
              size="small"
              startIcon={<AdminPanelSettingsRoundedIcon />}
            >
              Администрирование
            </Button>
          )}

          <Button variant="outlined" size="small" onClick={logout} startIcon={<LogoutRoundedIcon />}>
            Выйти
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
